import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import LocalSpinner from '../../shared/components/LocalSpinner';
import { DDPCheckoutDisclaimer, DAPCheckoutDisclaimer } from './DutiesMessages';

import { CheckoutTotalsDutiesMessage_transaction$key } from './__generated__/CheckoutTotalsDutiesMessage_transaction.graphql';
type CheckoutTotalsDutiesMessageProps = {
    transaction: CheckoutTotalsDutiesMessage_transaction$key | null;
    isComputing: boolean;
};

const CheckoutTotalsDutiesMessage: FC<CheckoutTotalsDutiesMessageProps> = ({
    transaction: transactionRef,
    isComputing,
}) => {
    const transaction = useFragment(
        graphql`
            fragment CheckoutTotalsDutiesMessage_transaction on Transaction {
                crossBorderIncoterm
            }
        `,
        transactionRef
    );

    //New customs messaging depends on whether transaction is cross customs border and incoterm
    const crossBorderIncoterm = transaction?.crossBorderIncoterm;

    if (!crossBorderIncoterm) {
        //Return null when transaction is not cross border
        return null;
    }

    let newDutiesMessage = null;

    if (crossBorderIncoterm === 'DDP') {
        newDutiesMessage = DDPCheckoutDisclaimer;
    } else if (crossBorderIncoterm === 'DAP') {
        newDutiesMessage = DAPCheckoutDisclaimer;
    }

    const showCheckoutCustomsMessage = isComputing ? (
        <span>
            <LocalSpinner inline />
        </span>
    ) : (
        <div>{newDutiesMessage}</div>
    );

    return <>{showCheckoutCustomsMessage}</>;
};

export default CheckoutTotalsDutiesMessage;
